import { ITongHopHocPhiActions } from "../../action-types/tong-hop/ITongHopHocPhiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import {
  ITongHopHocPhiReducer,
  ITongHopHocPhiRequest,
} from "../../reducer-model/tong-hop/ITongHopHocPhiReducer";
const iniState: ITongHopHocPhiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_not_initialization,
  filter: {
    id_chuyen_nganh: 0,
    khoa_hoc: 0,
    id_he: 0,
    hoc_ky: 0,
    nam_hoc: "",
  } as ITongHopHocPhiRequest,
};
export const TongHopHocPhiReducer = (
  state: ITongHopHocPhiReducer = iniState,
  actions: ITongHopHocPhiActions
): ITongHopHocPhiReducer => {
  switch (actions.type) {
    case "TONG_HOP_HOC_PHI_CHANGE_FILTER":
      return {
        ...state,
        filter: {
          ...state.filter,
          ...actions.payload,
        },
      };
    case "TONG_HOP_HOC_PHI_EXPORT_EXCEL_START":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_loading,
      };
    case "TONG_HOP_HOC_PHI_EXPORT_EXCEL_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "TONG_HOP_HOC_PHI_EXPORT_EXCEL_ERROR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
